import { DSAccordion } from 'designSystem/DSAccordion';
import EventLiveCardView from 'features/eventLive/component/eventLiveCardView';
import { MarketTypesState } from 'features/eventLive/interface/interface';
import isEmpty from 'lodash/isEmpty';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import RefreshableContent from 'shared/components/RefreshableContent';
import TabAnimationWrapper from 'shared/components/tabAnimationWrapper/tabAnimationWrapper';
import { APP_URL, TRACKER_TABS } from 'shared/constants/common';
import { isMobile, removeMultipleDash, removeSpecialCharacter } from 'shared/util/utility';
import { EventState, GamesState } from '../../interface/sportPrematch';
import BetBuilder from '../betBuilder';
import './styles.scss';

interface PreMatchBetOptionsProps {
	eventDetailData: EventState;
	currentMarketType: MarketTypesState[];
	customeBets: number[];
	setBetBuilderArray: (param: GamesState[]) => void;
	fetchPreMatchEventDetail: () => Promise<void>;
	selectedOddsArray: GamesState[];
	setSelectedOddsArray: Dispatch<SetStateAction<GamesState[]>>;
	totalOdds: number;
	setTotalOdds: Dispatch<SetStateAction<number>>;
	activePillTab: string;
	filteredList: GamesState[];
	conflictedIds: number[];
	setConflictedIds: Dispatch<SetStateAction<number[]>>;
	filteredGames: any;
	isFootball?: boolean;
	activeTrackerTab: any;
}

const getLiveEventUrl = (eventDetailData: EventState) => {
	const eventData = eventDetailData;
	const URL = `${APP_URL.live}/${removeSpecialCharacter(eventData.categoryName)}/${removeSpecialCharacter(eventData.eventName)}/${
		eventData.eventExtendedData.liveEventId
	}`;
	return removeMultipleDash(URL);
};

const PreMatchBetOptions = ({
	eventDetailData,
	currentMarketType,
	selectedOddsArray,
	setSelectedOddsArray,
	customeBets,
	setBetBuilderArray,
	fetchPreMatchEventDetail,
	totalOdds,
	setTotalOdds,
	activePillTab,
	filteredList,
	conflictedIds,
	setConflictedIds,
}: PreMatchBetOptionsProps) => {
	const { t } = useTranslation();

	const renderMarketType = (item: any, index: number) => {
		const itemsToPrint =
			filteredList.length > 0 ? item.gameIds.filter((singleId: number) => filteredList.some((item) => item.gameId === singleId)) : item.gameIds;

		return (
			<DSAccordion
				settings={{ stateType: 'prematch', stateKey: eventDetailData.sportId, stateValue: item.marketType, defaultCollapsed: true }}
				titleTag="h1"
				className="mb-4"
				type="secondary"
				title={t(`marketType_${item.marketType}`)}
			>
				<div className="pre-match" key={`currentMarketType-${index}`}>
					<div className="preMatchOptions">
						{itemsToPrint.map((game: any, index: number) => {
							return (
								<div className="live-game-wrapper" key={`gameIds-${index}`}>
									<EventLiveCardView
										className="live-game__card"
										gameDetail={{
											...eventDetailData,
											...eventDetailData.games.find((item) => item.gameId === game),
										}}
										isLive={false}
										eventViewOdds={true}
									/>
								</div>
							);
						})}
					</div>
				</div>
			</DSAccordion>
		);
	};

	const filteredMarketTypes = currentMarketType.filter((item) => item.marketType.toString() === activePillTab?.toString());
	const renderFilteredMarketTypes = filteredMarketTypes.map(renderMarketType);
	const renderMarketTypes = activePillTab === TRACKER_TABS.COURSES && currentMarketType.map(renderMarketType);

	return (
		<>
			{eventDetailData.eventExtendedData?.liveEventId || eventDetailData.result ? (
				<>
					<div id="pre-match-body" className="event-not-found">
						<p className="event-not-found-text">{t('eventWentLiveText')}</p>
						{eventDetailData.eventExtendedData?.liveEventId && (
							<div className={`${isMobile() ? 'event-went-live' : 'empty-bet-desktop'} empty-bet`}>
								<NavLink
									to={getLiveEventUrl(eventDetailData)}
									className={`empty-bet--button text--uppercase ${!isMobile() && 'empty-bet--button-desktop'}`}
								>
									{t('eventWentLiveButton')}
								</NavLink>
							</div>
						)}
					</div>
				</>
			) : (
				<>
					<div id="pre-match-body">
						<RefreshableContent onRefresh={() => fetchPreMatchEventDetail()}>
							<TabAnimationWrapper>
								{/* {isFootball && activeTrackerTab !== TRACKER_TABS.BET_BUILDER && renderFootballCards()} */}

								{/* {!isFootball && isEmpty(filteredMarketTypes) ? renderMarketTypes : renderFilteredMarketTypes} */}
								{isEmpty(filteredMarketTypes) ? renderMarketTypes : renderFilteredMarketTypes}
								{activePillTab === TRACKER_TABS.BET_BUILDER && (
									<BetBuilder
										customeBets={customeBets}
										eventDetailData={eventDetailData}
										setBetBuilderArray={setBetBuilderArray}
										selectedOddsArray={selectedOddsArray}
										setSelectedOddsArray={setSelectedOddsArray}
										totalOdds={totalOdds}
										setTotalOdds={setTotalOdds}
										conflictedIds={conflictedIds}
										setConflictedIds={setConflictedIds}
									/>
								)}
							</TabAnimationWrapper>
						</RefreshableContent>
					</div>
				</>
			)}
		</>
	);
};

export default PreMatchBetOptions;
